/* eslint-env jquery, browser */
import mprogress from '../assets/plugins/mprogressbar';

window.mprogress = mprogress;
